import { Stack, Typography } from '@mui/joy';
import { LockSimple, LockSimpleOpen } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';

import { PricingProfileAccessType } from 'pricing/types';
import { Direction, Level } from 'theme/enums';

interface IProps {
  value: PricingProfileAccessType;
}

export const AccessTypeCell = ({ value }: IProps) => {
  const { t } = useTranslation();

  const isPrivate = value === PricingProfileAccessType.USER;

  return (
    <Stack alignItems="center" direction={Direction.ROW} gap={0.5}>
      {isPrivate ? <LockSimple size={16} weight="fill" /> : <LockSimpleOpen size={16} />}
      <Typography level={Level.BODY_SM}>
        {isPrivate ? t('labelPrivate') : t('labelPublic')}
      </Typography>
    </Stack>
  );
};
